import createInstance from "./instance";
import field from "./v2/field";
import farm from "./v2/farm";
import historical from "./v2/field/historical";
import historicalV3 from "./v3/field/historical";
import fieldId from "./v2/field/[fieldId]";
import farmId from "./v2/farm/[farmId]";
import attributeSyncKeys from "./v0/field-attribute/sync-keys";
import revisionSyncKeys from "./v0/field-revision/sync-keys";

const fieldsSvc = {
  createInstance,
  getFields: historical.GET,
  v3: {
    getFields: historicalV3.GET,
  },
  addField: field.POST,
  deleteField: fieldId.DELETE,
  getFarms: farm.GET,
  addFarm: farm.POST,
  updateFarm: farmId.PUT,
  deleteFarm: farmId.DELETE,
  syncFieldAttributes: attributeSyncKeys.GET,
  syncFieldRevisions: revisionSyncKeys.GET,
};

export default fieldsSvc;

export * from "./instance";
export * from "./schemas";
